<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MQD792/tc-custom/9781614230359.jpg?1708803119882" alt="This image is the cover for the book Union is Dissolved!, Civil War Sesquicentennial Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Union is Dissolved!, Civil War Sesquicentennial Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Join Charleston historian Doug Bostick as he traces the political turmoil of 1860 and early 1861, when the firebrands of secession in Charleston were pushing the South to act together in a decisive way. The Union Is Dissolved chronicles the face-off between professor and student--Robert Anderson and Pierre G.T. Beauregard--and the firing on Fort Sumter, signaling the beginning of the American Civil War. Featuring many historical images and first-person accounts found in period newspapers and family papers, this fascinating volume offers a concise introduction to our nation's greatest struggle.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Douglas W Bostick
      </h2>
      
      <p class="authorDescription body article">Doug Bostick is a native of James Island and is an eighth-generation South Carolinian. He is a graduate of the College of Charleston and earned a master's degree from the University of South Carolina. Bostick is a former staff and faculty member of the University of South Carolina and the University of Maryland. He is the author of fifteen books, and his knowledge of history is enhanced by a raconteur's gift for storytelling.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f352db4